import React, { ReactNode } from 'react'
import { Container } from './AlertContainer.styles'
import { Alert } from 'uol-host-react-ui'
import { AlertProps, AlertVariant } from 'uol-host-react-ui/dist/molecules/Alert/Alert.types';
import { variantValues } from './variantValues';

export interface AlertContainerProps {
    variant: AlertVariant
    title?: string,
    description?: string,
    showDescription?: boolean,
    children?: ReactNode,
    alertProps?: Omit<AlertProps, 'variant'>,
}

export function AlertContainer({ variant, title, description, showDescription = true, children, alertProps, ...props }: AlertContainerProps) {
    const renderingDescription = description ?? variantValues[variant]?.description ?? ''
    const renderingTitle = title ?? variantValues[variant]?.header ?? ''

    return <Container {...props}>

        <Alert {...alertProps} variant={variant}>
            {children ||
                <>
                    <strong>
                        {renderingTitle}
                    </strong>
                    {showDescription && <p>{renderingDescription}</p>}
                </>
            }

        </Alert>
    </Container>
}   